<ng-container *ngIf="deviceType() === 'desktop'; then deskTopHeader; else mobileTabletHeader" />

<!-- Desktop Header -->
<ng-template #deskTopHeader>
  <div class="custom-header container" [ngClass]="{ 'sticky-desktop-header': isSticky() }" [ngClass]="deviceType()">
    <div class="d-flex align-items-center">
      <!-- Logo Section -->
      <div class="custom-header-logo-container logo-left">
        <ng-container *ngTemplateOutlet="desktopLogo" />
      </div>

      <!-- Navigation and Utilities -->
      <div class="custom-header-nav-utils-container">
        <div class="custom-header-nav-utils">
          <div class="custom-header-utils">
            <div class="d-flex justify-content-end header-user-links">
              <ul class="user-links">
                <!-- Search -->
                <li
                  *ishNotFeature="'sparqueSearch'"
                  class="search-container-list"
                  (isClickedOutside)="hideSearchBox()"
                  ishClickOutside
                  [ngClass]="{ 'active-search-box': showSearchBox }"
                >
                  <button class="search-toggle-icon" (click)="showOrHideSearchBox()">
                    <fa-icon [icon]="['fas', 'search']" />
                  </button>
                  <div class="search-container header-search-container" [ngClass]="getSearchBoxAnimationClass()">
                    <ng-container *ngTemplateOutlet="searchBoxTemplate" />
                  </div>
                </li>
                <li
                  *ishFeature="'sparqueSearch'"
                  class="search-container-list"
                  [ngClass]="{ 'active-search-box': showSearchBox }"
                  (isClickedOutside)="hideSearchBox()"
                  ishClickOutside
                >
                  <button class="search-toggle-icon" (click)="showOrHideSearchBox()">
                    <fa-icon [icon]="['fas', 'search']" />
                  </button>
                  <div class="search-container header-search-container" [ngClass]="getSearchBoxAnimationClass()">
                    <ng-container *ngTemplateOutlet="searchBoxTemplate" />
                  </div>
                </li>

                <!-- Login -->
                <li
                  class="search-login-icon"
                  [ngClass]="{ 'active-login-container': showSignIn }"
                  ishClickOutside
                  (isClickedOutside)="showOrHideSignIn('clickedOutside')"
                >
                  <button class="search-toggle-icon" (click)="showOrHideSignIn()" [ngClass]="{ hover: showSignIn }">
                    <i class="icon-users"></i>
                  </button>
                  <div class="login-container" [ngClass]="getSignInAnimationClass()">
                    <custom-login-status />
                  </div>
                </li>

                <!-- Features -->
                <li *ishFeature="'compare'">
                  <ish-lazy-product-compare-status data-testing-id="compare-status-desktop" />
                </li>
                <li *ishFeature="'orderTemplates'">
                  <a routerLink="/account/order-templates"><i class="icon-heart"></i></a>
                </li>
                <li *ishFeature="'wishlists'" class="d-none d-md-block">
                  <ish-lazy-wishlists-link />
                </li>
                <ng-container *ngTemplateOutlet="miniBasketLanguageSwitch" />
              </ul>
            </div>
          </div>

          <!-- Global Navigation -->
          <div class="global-nav-container" id="globalNavigation" #globalNavigation>
            <nav
              class="global-nav navbar-expand-md"
              id="global-nav"
              [ngbCollapse]="!showNavBar"
              aria-label="main"
              #globalNav
              (scroll)="onScroll()"
              (mouseenter)="onScroll()"
            >
              <ng-container *ngTemplateOutlet="naviagtions" />
            </nav>
          </div>
        </div>
      </div>

      <!-- Mini Basket -->
      <div class="header-utility">
        <custom-mini-basket
          data-testing-id="mini-basket-mobile"
          view="small"
          [ngClass]="isSticky() ? 'd-lg-none' : 'd-md-none'"
        />
      </div>
    </div>
  </div>
</ng-template>

<!-- Mobile/Tablet Header -->
<ng-template #mobileTabletHeader>
  <div class="container-fluid search-mobile-con-cards">
    <div class="row">
      <!-- Hamburger Menu and Logo -->
      <div class="col-2">
        <div class="d-flex">
          <button class="navbar-toggler" type="button" (click)="toggle('navbar')">
            <span class="sr-only">{{ 'common.button.navbarCollapsed.text' | translate }}</span>
            <div class="hamburger-menu" [ngClass]="{ open: showNavBar }"><span></span> <span></span> <span></span></div>
          </button>
          <div class="logo-wrapper">
            <a
              rel="home"
              [routerLink]="isInsideUveEditor ? '/page/index' : '/home'"
              (click)="emitdotcmsHomePageEditEvent()"
              class="mobile-logo"
              data-testing-id="header-home-link-mobile"
            ></a>
          </div>
        </div>
      </div>

      <!-- User Links -->
      <div class="col-10 custom-utils-align">
        <div class="header-user-links d-flex justify-content-end">
          <ul class="user-links">
            <ng-container *ishNotFeature="'sparqueSearch'">
              <li class="product-search">
                <div class="header-search-container">
                  <ng-container *ngTemplateOutlet="searchBoxTemplate" />
                </div>
              </li>
            </ng-container>

            <li class="custom-mob-login-status">
              <custom-login-status *ngIf="deviceType() === 'tablet'" data-testing-id="user-status-desktop" />
            </li>
            <ng-container *ishFeature="'sparqueSearch'">
              <li>
                <custom-login-status *ngIf="deviceType() === 'mobile'" view="auto" />
              </li>
            </ng-container>

            <ng-container *ishFeature="'sparqueSearch'">
              <li class="product-search" #searchBoxWrapper>
                <div class="header-search-container">
                  <button
                    class="search-toggle-icon"
                    [ngClass]="{ 'mobile-custom-search-box-active': showSearchBox }"
                    (click)="showOrHideSearchBox()"
                  >
                    <fa-icon [icon]="['fas', 'search']" />
                  </button>
                  <div class="sparque-search-box" [ngClass]="{ 'sparque-active-search-box': showSearchBox }">
                    <ng-container *ngTemplateOutlet="searchBoxTemplate" />
                  </div>
                  <ng-container *ishNotFeature="'sparqueSearch'">
                    <div class="sparque-search-box" [ngClass]="{ 'active-search-box': showSearchBox }">
                      <ng-container *ngTemplateOutlet="searchBoxTemplate" />
                    </div>
                  </ng-container>
                </div>
              </li>
            </ng-container>

            <li *ishFeature="'compare'" class="custom-mob-compare">
              <ish-lazy-product-compare-status data-testing-id="compare-status-desktop" />
            </li>
            <li *ishFeature="'orderTemplates'" class="custom-mob-order-template">
              <a routerLink="/account/order-templates"><i class="icon-heart"></i></a>
            </li>
            <li *ishFeature="'wishlists'" class="custom-mob-wishlist">
              <ish-lazy-wishlists-link />
            </li>
            <ng-container *ngTemplateOutlet="miniBasketLanguageSwitch" />
          </ul>
        </div>
      </div>

      <!-- Sales Rep -->
      <div
        *ngIf="deviceType() !== 'desktop' && !showNavBar && !isInsideIframe()"
        class="col-12 pt-2 custom-lazy-sales-rep"
        [ngClass]="{ 'custom-lazy-sales-rep-active': showSearchBox }"
      >
        <custom-lazy-sales-rep-users-list />
      </div>
    </div>
  </div>
  <ng-container *ngTemplateOutlet="mainNavigationLinks" />
</ng-template>

<!-- Common Templates -->
<ng-template #searchBoxTemplate let-icon="icon">
  <ng-container *ishFeature="'sparqueSearch'">
    <ish-search-box
      data-testing-id="search-box-desktop"
      [deviceType]="deviceType()"
      [configuration]="{
        placeholder: 'search.searchbox.instructional_text' | translate,
        autoSuggest: true,
        maxAutoSuggests: 5,
        icon: icon
      }"
      (closeSearchBox)="onCloseSearchBox()"
      (hideSearchBox)="showSearchBox = false"
      [shouldFocus]="shouldFocusSearch"
    />
  </ng-container>
  <ng-container *ishNotFeature="'sparqueSearch'">
    <custom-lazy-search-box
      data-testing-id="search-box-desktop"
      [configuration]="{
        placeholder: 'dias.search.searchbox.instructional_text' | translate,
        autoSuggest: true,
        maxAutoSuggests: 10,
        icon: icon
      }"
    />
  </ng-container>
</ng-template>

<ng-template #mainNavigationLinks>
  <div class="global-nav-container">
    <nav class="global-nav navbar-expand-md" [ngbCollapse]="!showNavBar" aria-label="main">
      <ng-container *ngTemplateOutlet="naviagtions" />
    </nav>
  </div>
</ng-template>

<ng-template #naviagtions>
  <div class="main-navigation" role="navigation" #navigaitions>
    <custom-header-navigation />
    <custom-user-information-mobile />
  </div>
</ng-template>

<ng-template #desktopLogo>
  <a rel="home" [routerLink]="getHomePageUrl()" class="logo" data-testing-id="header-home-link-desktop"></a>
</ng-template>

<ng-template #miniBasketLanguageSwitch>
  <li class="custom-min-box">
    <custom-mini-basket
      data-testing-id="mini-basket-desktop"
      style="top: 0"
      [view]="deviceType() === 'mobile' ? 'small' : 'full'"
      class="d-md-inline-block"
    />
  </li>
  <li *ngIf="!isInsideIframe()" class="custom-language-box">
    <custom-language-switch data-testing-id="language-switch-desktop" />
  </li>
</ng-template>
